<div #treeContainer style="height: 650px">
  <dx-tree-view
    #treeView
    id="fitting-treeview"
    [dataSource]="dataSource"
    [selectionMode]="'single'"
    [expandEvent]="'click'"
    [width]="'100%'"
    [height]="'100%'"
    [ngClass]="'fitTreeView'"
    (onItemClick)="onItemClick($event)"
  >
  </dx-tree-view>
</div>